export default {
  store_self(state, self) {
    state.self = self;
  },
  set_user_settings(state, settings) {
    state.settings = settings;
  },
};
